@let info = withdrawalInfo();
@let formattedAmount = amount() | decimal: "1.2-8";

<iw-details-value
  label="withdrawal.details.crypto.walletTo"
  [value]="info.targetCryptoAddress"
  withCopyBtn
/>

<iw-details-value
  label="withdrawal.details.crypto.commission"
  [iconName]="estimatedFee()?.symbol.toLowerCase() || ''"
  tooltipValue="withdrawal.details.crypto.commission.tooltip"
  [value]="
    loading() ? null : (estimatedFee()?.fee | decimal: '1.2-8') || '0.00'
  "
>
  @if (loading()) {
    <iw-shimmer count="1" width="120" height="20" />
  }
</iw-details-value>

<iw-details-value
  label="withdrawal.details.crypto.details"
  [value]="info.description?.trim() || '-'"
/>

<iw-details-value
  [iconName]="currencySymbol()"
  label="withdrawal.details.finalAmount"
  [value]="loading() ? null : formattedAmount"
  tooltipValue="withdrawal.details.crypto.totalAmount.tooltip"
>
  @if (loading()) {
    <iw-shimmer count="1" width="120" height="20" />
  }
</iw-details-value>
